import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=574b3c94&"
import script from "./Law.vue?vue&type=script&lang=js&"
export * from "./Law.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports